import React from "react";
import { ARTIST, LOGO } from "../lib/site";
import { TikTokIcon, InstagramIcon, YouTubeIcon } from "./BrandIcons";
import { Mail } from "lucide-react";
import { trackClick } from "../lib/analytics";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/[0.06] py-16">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-10 items-center">
      <div>
        <img src={LOGO} alt="AKALIBE" className="h-14 w-auto" />
        <p className="text-[#8A8A8A] text-sm mt-4 max-w-xs">{ARTIST.tagline}</p>
      </div>
      <div className="flex md:justify-center gap-4">
        <a href={ARTIST.tiktok} target="_blank" rel="noopener noreferrer" onClick={() => trackClick("tiktok")} data-testid="footer-tiktok"
           className="w-11 h-11 border border-white/[0.1] flex items-center justify-center text-white/70 hover:text-gold hover:border-gold/40 transition-colors">
          <TikTokIcon size={18} />
        </a>
        <a href={ARTIST.instagram} target="_blank" rel="noopener noreferrer" onClick={() => trackClick("instagram")} data-testid="footer-instagram"
           className="w-11 h-11 border border-white/[0.1] flex items-center justify-center text-white/70 hover:text-gold hover:border-gold/40 transition-colors">
          <InstagramIcon size={18} />
        </a>
        <a href={ARTIST.youtube} target="_blank" rel="noopener noreferrer" onClick={() => trackClick("youtube")} data-testid="footer-youtube"
           className="w-11 h-11 border border-white/[0.1] flex items-center justify-center text-white/70 hover:text-gold hover:border-gold/40 transition-colors">
          <YouTubeIcon size={18} />
        </a>
        <a href={`mailto:${ARTIST.email}`} data-testid="footer-email"
           className="w-11 h-11 border border-white/[0.1] flex items-center justify-center text-white/70 hover:text-gold hover:border-gold/40 transition-colors">
          <Mail size={17} />
        </a>
      </div>
      <div className="md:text-right">
        <a href={`mailto:${ARTIST.email}`} className="text-[#A3A3A3] text-sm hover:text-gold transition-colors">{ARTIST.email}</a>
        <p className="text-[#8A8A8A] text-xs tracking-wide mt-3">
          © {new Date().getFullYear()} AKALIBE. Tous droits réservés.
        </p>
        <a href="/login" data-testid="footer-admin-link" className="text-[#8A8A8A] text-xs hover:text-gold transition-colors mt-2 inline-block">
          Espace artiste →
        </a>
      </div>
    </div>
  </footer>
);
